import { Avatar, useTheme } from '@mui/material';
import React from 'react';
import EmptyAvatar from './EmptyAvatar';

function AccountAvatar({
  image,
  selectedColor,
  accountName,
  size = 56,
}: {
  image?: string | null;
  selectedColor?: string | null;
  accountName: string;
  size?: number;
}) {
  const theme = useTheme();
  const colorDefault = accountName ? theme.palette.grey[400] : 'transparent';
  const color = selectedColor || colorDefault;

  const initials = React.useMemo(() => {
    const initialsWithoutSpecialChar = accountName.replace(/[^\w\s]/gi, '');
    const initials = initialsWithoutSpecialChar
      .split(' ')
      .map((n) => n[0])
      .join('')
      .substring(0, 2)
      .toUpperCase();

    if (initials.length === 1) {
      return initialsWithoutSpecialChar.substring(0, 2).toUpperCase();
    }

    if (initials.length === 0) {
      return <EmptyAvatar {...{ size }} />;
    }

    return initials;
  }, [accountName, size]);

  return (
    <Avatar
      alt={accountName}
      src={image || undefined}
      sx={{
        bgcolor: image ? undefined : color,
        p: selectedColor ? '2px' : undefined,
        border: selectedColor ? `4px ${color} solid` : undefined,
        '.MuiAvatar-img': { borderRadius: '50%' },
        boxSizing: 'border-box',
        width: size,
        height: size,
      }}
    >
      {initials}
    </Avatar>
  );
}

export default AccountAvatar;
